import { UserContentType } from '@/types';
import AddTextContent from './AddTextContent';
import AddDrawingContent from './AddDrawingContent';
import AddLinkContent from './AddLinkContent';

interface AddNoteProps {
  addingNoteType: UserContentType;
  saveNote: (content: string) => void;
}
const AddNote: React.FC<AddNoteProps> = ({ addingNoteType, saveNote }) => {
  return (
    <>
      {addingNoteType === UserContentType.Text && (
        <AddTextContent saveNote={saveNote} />
      )}
      {addingNoteType === UserContentType.Drawing && (
        <AddDrawingContent saveNote={saveNote} />
      )}
      {addingNoteType === UserContentType.Link && (
        <AddLinkContent saveNote={saveNote} />
      )}
       {addingNoteType === UserContentType.Image && (
        <AddLinkContent saveNote={saveNote} />
      )}
    </>
  );
};

export default AddNote;
